import React from 'react';
import { connect } from 'react-redux';
import Row from './row';

/* eslint react/no-array-index-key:0 */

const ContentTableBody = ({ data, lastFetched, selectedContentType }) => (
  <div className="Content-tableBody Table-body">
    {data.map((content, i) => (
      <Row
        key={`${i}_${lastFetched}`}
        index={i}
        {...content}
        selectedContentType={selectedContentType}
      />
    ))}
  </div>
);

const mapStateToProps = ({ filter, data }) => ({
  data: data.content,
  lastFetched: data.lastFetched,
  selectedContentType: filter.type,
});

export default connect(mapStateToProps)(ContentTableBody);
